import { Component, OnInit, Input } from '@angular/core';
import { AuthService } from '../../../services/auth.service';
import { Router, ActivatedRoute } from '@angular/router';
import { ToastService } from '../../../services/toast.service'; // Import the ToastService
import { StripeService } from '../../../services/stripe.service';
import { StorageService } from '../../../services/storage.service';

@Component({
  selector: 'app-reset-password',
  templateUrl: './reset-password.component.html',
  styleUrls: ['./reset-password.component.scss'],
})
export class ResetPasswordComponent {
  showPassword: { newPassword: boolean; confirmPassword: boolean } = {
    newPassword: false,
    confirmPassword: false,
  };
  @Input() email: string = '';
  newPassword: string = '';
  confirmPassword: string = '';
  errorMessage: string = '';
  otp: string = '';

  constructor(
    private router: Router,
    private authService: AuthService,
    private route: ActivatedRoute,
    private toastService: ToastService,
    private storageService: StorageService
  ) {} // Inject the ToastService

  togglePasswordVisibility(
    field: 'newPassword' | 'confirmPassword',
    passwordInput: HTMLInputElement
  ) {
    this.showPassword[field] = !this.showPassword[field];
    passwordInput.type = this.showPassword[field] ? 'text' : 'password';
  }

  resetPassword(): void {
    if (this.newPassword !== this.confirmPassword) {
      this.errorMessage = 'Passwords do not match!';
      this.toastService.showToast('Passwords do not match', 'error'); // Show toast for password mismatch
      return;
    }

    const userData = {
      email: this.email,
      password: this.newPassword,
    };

    this.authService.setPassword(userData).subscribe({
      next: (response: any) => {
        const userToStore = {
          _id: response.user._id,
          email: response.user.email,
          name: response.user.name,
          is_email_verified: response.user.is_email_verified,
          is_active: response.user.is_active,
        };
        this.storageService.setUserSubscription(response?.subscription);
        this.authService.setAuthData(response.token, userToStore);
        this.toastService.showToast('Password reset successfully!', 'success');
        this.router.navigate(['/'], { replaceUrl: true });
        setTimeout(() => {
          this.toastService.showToast('Logged in successfully!', 'success');
        }, 100);
      },
      error: (error) => {
        const errorMessage =
          error?.message || 'An error occurred during password reset.';
        this.toastService.showToast(errorMessage, 'error');
        console.error('Error resetting password', error);
      },
    });
  }
}
